/* Collection-card image swap ("on-body peek").
   - Click on the arrow cycles main -> alt1 -> ... -> main.
   - Touch: horizontal swipe on the card image (left = next, right = prev).
   Listeners are delegated on document because <collection-load-more>
   (assets/main-collection.js) appends new cards to #product-grid via
   insertAdjacentHTML. Only cards rendered with enable_image_swap carry
   [data-image-swap]. Loaded (defer) by main-collection-product-grid.liquid. */
(() => {
  const WRAPPER = '.card-wrapper[data-image-swap]';
  const SWIPE_THRESHOLD = 40; // px of horizontal travel
  const DOMINANCE = 1.5; // |dx| must beat |dy| by this factor so vertical scroll passes through

  function step(wrapper, delta) {
    const imgs = wrapper.querySelectorAll('.media--swap > img');
    if (imgs.length < 2) return;
    let current = Array.prototype.findIndex.call(imgs, (img) => img.classList.contains('is-active'));
    if (current < 0) current = 0;
    const next = (current + delta + imgs.length) % imgs.length;
    imgs[current].classList.remove('is-active');
    imgs[next].classList.add('is-active');
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-swap-next]');
    if (!button) return;
    const wrapper = button.closest(WRAPPER);
    if (!wrapper) return;
    event.preventDefault();
    event.stopPropagation();
    step(wrapper, 1);
  });

  // The card's link overlay (.card__heading a::after) covers the image, so
  // event.target for a touch on the image is the <a>; hit-test the touch Y
  // against .card__inner instead of relying on closest().
  let touch = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      touch = null;
      if (event.touches.length !== 1) return;
      const wrapper = event.target.closest(WRAPPER);
      if (!wrapper) return;
      const inner = wrapper.querySelector('.card__inner');
      if (!inner) return;
      const t = event.touches[0];
      const rect = inner.getBoundingClientRect();
      if (t.clientY < rect.top || t.clientY > rect.bottom) return;
      touch = { wrapper, x: t.clientX, y: t.clientY, dx: 0, dy: 0 };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!touch) return;
      const t = event.touches[0];
      touch.dx = t.clientX - touch.x;
      touch.dy = t.clientY - touch.y;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    () => {
      if (!touch) return;
      const { wrapper, dx, dy } = touch;
      touch = null;
      if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * DOMINANCE) {
        step(wrapper, dx < 0 ? 1 : -1);
        // Suppress the click the browser may synthesise after this touch.
        wrapper.dataset.swiped = 'true';
        setTimeout(() => {
          delete wrapper.dataset.swiped;
        }, 400);
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    () => {
      touch = null;
    },
    { passive: true }
  );

  // Capture phase so it runs before the card link navigates.
  document.addEventListener(
    'click',
    (event) => {
      const wrapper = event.target.closest(WRAPPER);
      if (wrapper && wrapper.dataset.swiped) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
